"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _async = _interopRequireDefault(require("react-select/async"));

var _debouncePromise = _interopRequireDefault(require("debounce-promise"));

var _formik = require("formik");

var _peractoUi = require("@peracto/peracto-ui");

var _peractoConfig = require("@peracto/peracto-config");

var _peractoHooks = require("@peracto/peracto-hooks");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTimes = require("@fortawesome/pro-regular-svg-icons/faTimes");

var _util = require("./util");

var yup = _interopRequireWildcard(require("yup"));

var _client = require("@peracto/client");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var NO_CONTENT = ['branch', 'directLink'];
var defaultSelectValue = {
  label: 'Please select...',
  value: ''
};
var urlProtocolPattern = /^((http|https):\/\/)/;

var convertToURLString = function convertToURLString(path) {
  return path.split(' ').join('-').replace(/[`~!$Â£â‚¬^*_|;@'",()<>\{\}\[\]\\]/gi, '').replace(/-+/g, '-');
};

var NavigationTreeForm = function NavigationTreeForm(_ref) {
  var _p_values$sub_urls, _p_values$sub_urls2, _p_values$sub_urls3;

  var _ref$values = _ref.values,
      values = _ref$values === void 0 ? {} : _ref$values,
      _ref$parent = _ref.parent,
      parent = _ref$parent === void 0 ? null : _ref$parent,
      _ref$onSubmitForm = _ref.onSubmitForm,
      onSubmitForm = _ref$onSubmitForm === void 0 ? function () {} : _ref$onSubmitForm,
      onClose = _ref.onClose;

  var _useClient = (0, _client.useClient)(),
      client = _useClient.client,
      getResource = _useClient.getResource;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      identifierValue = _useState2[0],
      setIdentifierValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      pathReadOnly = _useState4[0],
      setPathReadOnly = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      initialValues = _useState6[0],
      setInitialValues = _useState6[1];

  var config = (0, _peractoConfig.useConfig)();

  var _config$get = config.get('features', {}),
      navigation = _config$get.navigation;

  var readOnlyPaths = (navigation === null || navigation === void 0 ? void 0 : navigation.readOnlyPaths) || false;

  var _useSettings = (0, _peractoHooks.useSettings)(),
      p_values = _useSettings.values;

  var categoryPath = (p_values === null || p_values === void 0 ? void 0 : (_p_values$sub_urls = p_values.sub_urls) === null || _p_values$sub_urls === void 0 ? void 0 : _p_values$sub_urls.sitemap_categories_sub_url) || 'category';
  var articleCategoryPath = (p_values === null || p_values === void 0 ? void 0 : (_p_values$sub_urls2 = p_values.sub_urls) === null || _p_values$sub_urls2 === void 0 ? void 0 : _p_values$sub_urls2.sitemap_article_categories_sub_url) || 'articles';
  var articlePath = (p_values === null || p_values === void 0 ? void 0 : (_p_values$sub_urls3 = p_values.sub_urls) === null || _p_values$sub_urls3 === void 0 ? void 0 : _p_values$sub_urls3.sitemap_articles_sub_url) || 'article';
  var schema = (0, _client.getSchemaFromResource)(getResource('menu-items')).shape({
    menuCode: yup.string().notRequired(),
    path: yup.string().required(),
    linkText: yup.string().required()
  });

  var fetchOptions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(input, inputType) {
      var _getEndpointsForTypes, endpoint, params, itemKey, _yield$client, data, pathValue, values;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getEndpointsForTypes = (0, _util.getEndpointsForTypes)(inputType, input), endpoint = _getEndpointsForTypes.endpoint, params = _getEndpointsForTypes.params;
              itemKey = (0, _util.getKeyForIdentifierLabel)(inputType);
              _context.next = 4;
              return client(_client.GET_LIST, endpoint, _objectSpread({}, params));

            case 4:
              _yield$client = _context.sent;
              data = _yield$client.data;
              pathValue = '';
              _context.t0 = inputType;
              _context.next = _context.t0 === 'category' ? 10 : _context.t0 === 'content' ? 12 : _context.t0 === 'article' ? 12 : 14;
              break;

            case 10:
              pathValue = 'identifier';
              return _context.abrupt("break", 15);

            case 12:
              pathValue = 'slug';
              return _context.abrupt("break", 15);

            case 14:
              pathValue = 'path';

            case 15:
              values = data.map(function (item) {
                return {
                  label: item[itemKey],
                  value: item.originId,
                  path: item[pathValue] || null
                };
              });
              return _context.abrupt("return", values);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchOptions(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var debouncedFetchOptions = (0, _debouncePromise["default"])(fetchOptions, 200);

  var setDefaultIdentifierValue = function setDefaultIdentifierValue(content) {
    var keyName = (0, _util.getKeyForIdentifierLabel)(values.itemType);
    setIdentifierValue({
      label: content[keyName] || content['@id'],
      value: content.id
    });
  };

  var loadContentData = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var path, _yield$client2, data;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              path = values === null || values === void 0 ? void 0 : values.path;

              if (!(!path || NO_CONTENT.includes(values === null || values === void 0 ? void 0 : values.itemType))) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              if (path[0] === '/') {
                path = path.substr(1);
              }

              _context2.next = 6;
              return client(_client.GET_ONE, 'menu-items-by-path', {
                id: "menu-items-by-path/".concat(path)
              });

            case 6:
              _yield$client2 = _context2.sent;
              data = _yield$client2.data;

              if (data.content) {
                setDefaultIdentifierValue(data.content);
              } else {
                setIdentifierValue(defaultSelectValue);
              }

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function loadContentData() {
      return _ref3.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (values['@id'] && values.content) {
      setDefaultIdentifierValue(values.content);
    } else {
      loadContentData();
    }
  }, [values]);
  (0, _react.useEffect)(function () {
    setInitialValues(!!values['@id'] ? _objectSpread({}, values) : {
      linkType: 'external',
      identifier: '',
      linkText: '',
      menuCode: '',
      path: '',
      displayFrom: '',
      displayTo: ''
    });
    return function () {
      setInitialValues({});
    };
  }, [setInitialValues, values]);
  return /*#__PURE__*/_react["default"].createElement(_peractoUi.Form, {
    className: "w-100 text-left",
    values: initialValues,
    autoComplete: "off",
    onSubmit: function onSubmit(values, actions) {
      var parsedValues = _objectSpread({}, values);

      if (identifierValue !== null && identifierValue !== void 0 && identifierValue.value) {
        parsedValues.identifier = identifierValue.value;
      }

      onSubmitForm(parsedValues, actions);
    },
    showActionPanel: false,
    schema: schema
  }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "itemType"
  }, function (_ref4) {
    var form = _ref4.form,
        field = _ref4.field;
    return /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
      name: field.name,
      label: "Navigation Item Type",
      placeholder: "Please select...",
      options: _util.navigationTypeOptions,
      defaultValue: defaultSelectValue,
      handleChange: function handleChange() {
        form.setFieldValue('identifier', null);
        setIdentifierValue(defaultSelectValue);
      }
    });
  }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "identifier"
  }, function (_ref5) {
    var form = _ref5.form,
        field = _ref5.field;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !NO_CONTENT.includes(form.values.itemType) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react["default"].createElement("label", null, "Select Item"), /*#__PURE__*/_react["default"].createElement(_async["default"], {
      className: "w-100",
      classNamePrefix: "list",
      isDisabled: !form.values.itemType,
      loadOptions: function loadOptions(input) {
        return debouncedFetchOptions(input, form.values.itemType);
      },
      isSearchable: true,
      defaultValue: {
        label: 'Please Select',
        value: null
      },
      onChange: function onChange(option) {
        setIdentifierValue(option);
        form.setFieldValue(field.name, option.value);
        /* Set the Link Text to match the selected item's label by default */

        form.setFieldValue('linkText', option.label);
        /* Make the path field readonly if it's an article category and it already has a path */

        setPathReadOnly(form.values.itemType === 'articleCategory' && !!(option !== null && option !== void 0 && option.path));
        /* For article categories set the 'path' field as the one set on the article category. */

        var label = form.values.itemType === 'articleCategory' ? (option === null || option === void 0 ? void 0 : option.path) || option.label : option.label;
        /*  
            Set the Path based on the selected item's label by default 
            1. Prefix the URL with the parent's path if adding a child item
            2. Otherwise just use the item's label
        */

        var path = (option === null || option === void 0 ? void 0 : option.path) || (parent !== null && parent !== void 0 && parent.path ? "".concat(parent.path, "/").concat(label)
        /* [1] */
        : label);
        /* [2] */

        form.setFieldValue('path', convertToURLString(path).toLowerCase());
      },
      value: identifierValue,
      placeholder: "Select an option...",
      noOptionsMessage: function noOptionsMessage(_ref6) {
        var inputValue = _ref6.inputValue;

        if (inputValue.length > 0) {
          return "No items found for '".concat(inputValue, "'.");
        } else {
          return 'Enter text to begin searching.';
        }
      }
    })));
  }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "linkType"
  }, function (_ref7) {
    var field = _ref7.field,
        form = _ref7.form;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, form.values.itemType === 'directLink' && /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
      name: field.name,
      label: "Link type",
      placeholder: "Please select...",
      options: _util.directLinkTypeOptions,
      defaultValue: defaultSelectValue,
      handleChange: function handleChange(value) {
        var _form$values;

        var path = (form === null || form === void 0 ? void 0 : (_form$values = form.values) === null || _form$values === void 0 ? void 0 : _form$values.path) || '';

        if (form.values.itemType === 'directLink') {
          // If it's an external link, make sure the direct link starts with a protocol
          if (!urlProtocolPattern.test(path) && value === 'external') {
            form.setFieldValue('path', 'http://' + path);
          } // If it's an internal link, remove the protocol from the string


          if (urlProtocolPattern.test(path) && value === 'internal') {
            form.setFieldValue('path', path.replace(urlProtocolPattern, ''));
          }
        }
      }
    }));
  }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "linkText"
  }, function (_ref8) {
    var field = _ref8.field,
        form = _ref8.form;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
      name: field.name,
      label: "Link Text",
      placeholder: "Enter Link Text...",
      required: true,
      onBlur: function onBlur() {
        var _field$value, _form$values$path;

        if ((field === null || field === void 0 ? void 0 : (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.length) > 0 && form.values.itemType === 'branch' && ((_form$values$path = form.values.path) === null || _form$values$path === void 0 ? void 0 : _form$values$path.length) === 0) {
          // Strip slash at start of URL
          if (field.value[0] === '/') {
            field.value = field.value.substr(1);
          }

          form.setFieldValue('path', convertToURLString("menu-branch/".concat(field.value)));
        }
      }
    }));
  }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "path"
  }, function (_ref9) {
    var field = _ref9.field,
        form = _ref9.form;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, form.values.itemType && /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
      name: field.name,
      label: "Link Location",
      placeholder: "Enter Link Location...",
      prefix: form.values.itemType !== 'directLink' || form.values.itemType === 'directLink' && form.values.linkType === 'internal' ? "".concat(process.env.REACT_APP_STOREFRONT_URL || window.location.origin, "/").concat(form.values.itemType === 'category' ? "".concat(categoryPath, "/") : '').concat(form.values.itemType === 'articleCategory' ? "".concat(articleCategoryPath, "/") : '').concat(form.values.itemType === 'article' ? "".concat(articlePath, "/") : '') : null,
      onBlur: function onBlur() {
        var _field$value2;

        if ((field === null || field === void 0 ? void 0 : (_field$value2 = field.value) === null || _field$value2 === void 0 ? void 0 : _field$value2.length) > 0) {
          // Strip slash at start of URL
          if (field.value[0] === '/') {
            field.value = field.value.substr(1);
          } // If it's a direct link, make sure the URL starts with a protocol


          if (form.values.itemType === 'directLink' && form.values.linkType === 'external') {
            if (!urlProtocolPattern.test(field.value)) {
              field.value = 'http://' + field.value;
            }
          }

          form.setFieldValue(field.name, convertToURLString(field.value));
        }
      },
      readOnly: pathReadOnly || readOnlyPaths && !['directLink', 'branch'].includes(form.values.itemType),
      required: true
    }));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.DateRange, {
    fromName: "displayFrom",
    fromLabel: "Display From",
    toName: "displayTo",
    toLabel: "Display To"
  }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "displayFrom"
  }, function (_ref10) {
    var form = _ref10.form;
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-link px-0 ml-2",
      onClick: function onClick(e) {
        e.preventDefault();
        form.setFieldValue('displayFrom', null);
        form.setFieldValue('displayTo', null);
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faTimes.faTimes,
      className: "mr-2"
    }), "Clear");
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-outline-secondary",
    type: "button",
    onClick: function onClick(e) {
      e.preventDefault();
      onClose();
    }
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-success",
    type: "submit"
  }, "Submit")));
};

NavigationTreeForm.displayName = 'NavigationTreeForm';
var _default = NavigationTreeForm;
exports["default"] = _default;